/* eslint-disable global-require,import/no-unresolved, react/forbid-prop-types, react/no-array-index-key */
import React from 'react'
import {
 Dimensions, Text, View,
} from 'react-native'
import { useTranslation } from 'react-i18next'
import Image from 'react-native-scalable-image'
import styles from '../../../styles'
import textStyles from '../../../styles/text'
import panelStyles from '../../../styles/panel'
import * as ResourceManager from '../../methods/ResourceManager'

function ManualDataTransmission() {
  const { t } = useTranslation('faq')
  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={[textStyles.h1, styles.shark_grey]} testID="manual-transmit-paragraph1">{t('manuallyTransmitDataTitle')}</Text>
      </View>
      <View>
        <Text style={[textStyles.bodyContentText]} testID="manual-transmit-paragraph1">{t('manuallyTransmitDataParagraph1')}</Text>
        <Text style={[textStyles.bodyContentText]} testID="manual-transmit-paragraph2">{t('manuallyTransmitDataParagraph2')}</Text>
      </View>
      <View>
        <Text style={[textStyles.h3, styles.shark_grey]}>{t('manuallyTransmitDataSubTitle1')}</Text>
        <Text style={[textStyles.bodyContentText]} testID="manual-transmit-paragraph3">{t('manuallyTransmitDataParagraph3')}</Text>
        <Image
          style={[panelStyles.lightImage, styles.textMargin]}
          width={Dimensions.get('window').width - 32}
          source={{ uri: ResourceManager.loadImage('press_heart_button') }}
          accessibilityLabel={t('access:pressHeartButtonImage')}
          testID="press-heart-btn-image"
        />
      </View>
      <View>
        <Text style={[textStyles.h3, styles.shark_grey]}>{t('manuallyTransmitDataSubTitle2')}</Text>
        <Text style={[textStyles.bodyContentText]} testID="manual-transmit-paragraph3">{t('manuallyTransmitDataParagraph4')}</Text>
        <Image
          style={[panelStyles.lightImage, styles.textMargin]}
          width={Dimensions.get('window').width - 200}
          source={{ uri: ResourceManager.loadImage('all_green_waves_transparent') }}
          accessibilityLabel={t('access:allGreeenWavesImage')}
          testID="all-green-waves-image"
        />
        <Text style={[textStyles.bodyContentText]} testID="manual-transmit-paragraph3">{t('manuallyTransmitDataParagraph5')}</Text>
        <Text style={[textStyles.bodyContentText]} testID="manual-transmit-paragraph3">{t('manuallyTransmitDataParagraph6')}</Text>
      </View>
    </View>
  )
}
export default ManualDataTransmission
